import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { MinimalRateSchedule } from 'store/types';

export const initialRateState: MinimalRateSchedule = {
  MIN_NIGHTS: 1,
  BASE_RATE: '',
  ID: 0,
};

const calendarRateSlice = createSlice({
  name: 'calendarRateSlice',
  initialState: initialRateState,
  reducers: {
    setRate: (_, { payload }: PayloadAction<MinimalRateSchedule>) => payload,
    resetRate: () => {
      return initialRateState;
    },
  },
});

export const {
  reducer: calendarRateReducer,
  actions: { setRate, resetRate },
} = calendarRateSlice;
